import { Controller } from 'stimulus';

export default class extends Controller {
  update({ detail }) {
    this.element.value = detail.value;
  }
}
